<template>
  <div class="workresultlistdiv">
    <div class="title_h1">作業実績</div>
    <vab-query-form
      ref="queryForm"
      class="dpform DPR01G01"
      :model="queryForm"
      :rules="rules"
      size="mini"
      label-width="98px"
      @search="fetchData"
      @cancel="cancelSet"
    >
      <vab-row :gutter="24">
        <vab-col :lg="8" :xl="8" :md="12">
          <vab-date-picker
            ref="workYmRef"
            type="month"
            label="作業年月"
            value-format="yyyyMM"
            format="yyyy/MM"
            prop="workYm"
            class="width_140"
            validate="required"
            :clearable="false"
            @change="handleWorkYmChange"
          />
        </vab-col>
        <vab-col :lg="8" :xl="8" :md="12">
          <el-form-item class="big_label_110" label="予定日">
            <el-row>
              <el-col :span="24" class="searchdateinputrow">
                <vab-input
                  type="number"
                  :zero="false"
                  prop="planWorkStartDate"
                  class="searchdateinput"
                  maxlength="2"
                  :disabled="workYmlimit"
                  @change="setStartDate()"
                  @blur="blurTimeFrom"
                />
                <div class="searchdateinputsplit">日</div>
                <div class="space">〜</div>
                <vab-input
                  type="number"
                  :zero="false"
                  prop="planWorkEndDate"
                  class="searchdateinput"
                  :disabled="workYmlimit"
                  maxlength="2"
                  @change="setEndDate()"
                  @blur="blurTimeTo"
                />
                <div class="searchdateinputsplit">日</div>
              </el-col>
            </el-row>
          </el-form-item>
        </vab-col>

        <vab-col :lg="8" :xl="8" :md="12">
          <el-row type="flex">
            <el-col :span="24">
              <vab-input label="建物" prop="blgsnmkj" maxlength="62" />
            </el-col>
          </el-row>
        </vab-col>
        <vab-col :lg="8" :xl="8" :md="12">
          <MitmdtlpNew
            :componentcd.sync="queryForm.itemDetailCdList"
            prop="itemDetailCdList"
            :multi-select="false"
            :span1="7"
            :span2="17"
            @clearOtherData="clearOtherData"
          />
        </vab-col>
        <vab-collapse title="詳細検索を表示">
          <vab-col :lg="8" :xl="8" :md="12">
            <vab-select
              ref="workSpecRef"
              label="点検仕様"
              prop="workSpecCdList"
              :data-items="workSpecCdList"
              label-id="itmgkmnm"
              value-id="itmgkmcd"
              multiple
              collapse-tags
              clearable
              :disabled="workSpecCdListDisabled"
              placeholder="選択されていません"
            />
          </vab-col>
          <vab-col :lg="8" :xl="8" :md="12">
            <vab-select
              ref="resultDateInputStatusSelect"
              label="作業実績入力状況"
              prop="resultDateInputStatusList"
              filter="resultDateInputStatus"
              class="label_height"
              placeholder="選択されていません"
              clearable
              multiple
              collapse-tags
            />
          </vab-col>
        </vab-collapse>
      </vab-row>
    </vab-query-form>
    <vab-form ref="form" :model="form" :rules="rulesTable">
      <el-row>
        <el-col>
          <vab-table
            ref="table"
            api-url="/api/workingPlanAndResult/query-pl-list"
            :columns="columns"
            :nav-buttons="navButtons"
            :enable-init="reloadPage"
            :query-params="{
              ...setQueryParams(queryForm),
              sidx: 'workNo,workingPlanAndResultId',
              sort: 'desc,desc',
            }"
            :init-params="{
              ...setQueryParams(queryForm),
              sidx: 'workNo,workingPlanAndResultId',
              sort: 'desc,desc',
            }"
            primary-key="workingPlanAndResultId"
            :submit-mode="true"
            @submitTable="submitTable"
          >
            <template #datePicker="{ row, index }">
              <el-row class="flex_center_align el_row_box">
                <el-col class="flex_center_align flex_start">
                  <el-date-picker
                    v-model="row.resultWorkStartDate"
                    class="date_28"
                    :class="[
                      'date-picker-icon ',
                      row.resultWorkStartDate ? 'date-close w60' : 'w60',
                    ]"
                    type="date"
                    value-format="yyyy/MM/dd"
                    format="dd"
                    :disabled="
                      !isCurrentMonth ||
                      isEqualCodeEnum(
                        row.resultDateInputStatus,
                        $divisions.resultDateInputStatusEnum.enum_2
                      )
                    "
                    :row-item="row"
                    @change="timeReset($event, index)"
                  />
                  <!-- 当月以外の年月で検索する場合、作業実績作業日・作業実績開始時間・作業実績終了時間は入力不可となる -->
                  <span class="mlr6">日</span>
                  <span class="week_show">
                    {{ weekMatching(row.resultWorkStartDate) }}
                  </span>
                </el-col>
                <el-col class="flex_center_align flex_start time_50">
                  <vab-time-input
                    v-model="row.resultWorkStartTime"
                    label-error="作業実績日時"
                    :disabled="
                      !isCurrentMonth ||
                      isEqualCodeEnum(
                        row.resultDateInputStatus,
                        $divisions.resultDateInputStatusEnum.enum_2
                      ) ||
                      $baseLodash.isEmpty(row.resultWorkStartDate)
                    "
                    :validate="vaildateTimeStart(row, index)"
                    :row-item="row"
                    :prop="'tableList.' + index + '.resultWorkStartTime'"
                  />
                  <div class="mg6">〜</div>
                  <vab-time-input
                    v-model="row.resultWorkEndTime"
                    label-error="作業実績日時"
                    :disabled="
                      !isCurrentMonth ||
                      isEqualCodeEnum(
                        row.resultDateInputStatus,
                        $divisions.resultDateInputStatusEnum.enum_2
                      ) ||
                      $baseLodash.isEmpty(row.resultWorkStartDate)
                    "
                    :validate="vaildateTimeEnd(row, index)"
                    :row-item="row"
                    :prop="'tableList.' + index + '.resultWorkEndTime'"
                  />
                </el-col>
              </el-row>
            </template>
          </vab-table>
        </el-col>
      </el-row>
    </vab-form>
    <div class="flex_space mg12">
      <vab-button :btn-list="btnUpdate" />
    </div>
  </div>
</template>

<script>
  import reload from '@/utils/reload'
  import format from 'string-format'
  import { getFoundSelfData, workResultUpdate } from '@/api/rc/PWR02G04'
  export default {
    name: 'PWR02G04',
    extends: reload,
    data() {
      return {
        workYmlimit: true,
        leapYear: false,
        workSpecCdListDisabled: true,
        workSpecCdList: [],
        rules: {
          workYm: [
            {
              validator: this.workYmValidate,
              trigger: 'blur',
            },
          ],
        },
        rulesTable: {},
        queryForm: {
          supplierCdList: null,
          itemDetailCdList: [],
          workYm: null,
          resultDateInputStatusList: [],
        },
        form: {
          tableList: [],
        },
        navButtons: [
          {
            name: '予定を一括反映',
            hover: '#0071EE',
            defaultColor: '#ffffff',
            disabled: true,
            type: 'primary',
            click: this.handleWorkResultUpdateAll,
          },
        ],
        btnUpdate: [
          {
            name: '更新',
            type: 'button',
            icon: 'check_line',
            hidden: false,
            disabled: true,
            // msg: this.format(
            //   this.$t(`validateMessage.${this.$messageCode.I00000301.name}`),
            //   '更新'
            // ),
            click: () => {
              this.$refs['form'].validate((valid) => {
                if (valid) {
                  this.$confirm({
                    msg: this.format(
                      this.$t(
                        `validateMessage.${this.$messageCode.I00000301.name}`
                      ),
                      '更新'
                    ),
                    yesTex: '更新',
                    yes: async () => {
                      this.update()
                    },
                  })
                } else {
                  return false
                }
              })
            },
          },
        ],
        columns: [
          {
            label: '作業実績日時',
            'min-width': 278,
            fixed: 'left',
            sortable: false,
            slotScope: 'datePicker',
          },

          {
            label: '作業No',
            'min-width': 140,
            prop: 'workNo',
          },
          {
            label: '建物',
            'min-width': 240,
            prop: 'blgsnmkj',
          },
          // {
          //   label: '協力会社',
          //   'min-width': 240,
          //   prop: 'bcnfrkj',
          //   formatter: (row) => {
          //     if (row.bcnfrkjCheckOrganization) {
          //       return row.bcnfrkjCheckOrganization
          //     } else {
          //       return row.bcnfrkjSupplier
          //     }
          //   },
          // },
          {
            label: '商品明細',
            'min-width': 160,
            prop: 'itmdtlnm',
          },
          {
            label: '点検仕様',
            'min-width': 160,
            prop: 'workSpecName',
          },
          {
            label: '作業予定日時',
            'min-width': 240,
            sortable: false,
            formatter: (row) => {
              return this.getWorkDateTime(
                row.planWorkStartDate,
                row.planWorkStartTime,
                row.planWorkEndTime
              )
            },
          },
          {
            label: '発注金額',
            'min-width': 120,
            align: 'right',
            prop: 'purchaseOrderPriceNotax',
            type: 'number',
          },
          {
            label: '作業実績入力状況',
            'min-width': 160,
            prop: 'resultDateInputStatus',
            formatter: (row, column, cellValue) => {
              return this.getEnumText(
                cellValue,
                this.$divisions.resultDateInputStatusEnum
              )
            },
          },
          {
            type: 'actions',
            label: '操作',
            fixed: 'right',
            disableCheck: true,
            info: '予定を反映',
            disabled: (row) => {
              if (
                (this.isEqualCodeEnum(
                  row.resultDateInputStatus,
                  this.$divisions.resultDateInputStatusEnum.enum_0
                ) ||
                  this.$baseLodash.isEmpty(row.resultDateInputStatus) ||
                  this.$baseLodash.isNull(row.resultDateInputStatus) ||
                  this.isEqualCodeEnum(
                    row.resultDateInputStatus,
                    this.$divisions.resultDateInputStatusEnum.enum_1
                  )) &&
                this.isCurrentMonth
              ) {
                return false
              } else {
                return true
              }
            },
            width: 120,
            click: (row) => {
              this.handleWorkResultUpdate(row)
            },
          },
        ],
      }
    },
    computed: {
      vaildateTimeStart() {
        return (row, index) => {
          if (
            !(
              !this.isCurrentMonth ||
              this.isEqualCodeEnum(
                row.resultDateInputStatus,
                this.$divisions.resultDateInputStatusEnum.enum_2
              ) ||
              this.$baseLodash.isEmpty(row.resultWorkStartDate)
            )
          ) {
            this.$set(
              this.rulesTable,
              `tableList.${index}.resultWorkStartTime`,
              [
                {
                  required: true,
                  message: this.format(
                    this.$t(
                      `validateMessage.${this.$messageCode.E00000001.name}`
                    ),
                    '作業実績日時'
                  ),
                  trigger: 'blur',
                },
              ]
            )
          } else {
            this.$set(
              this.rulesTable,
              `tableList.${index}.resultWorkStartTime`,
              [
                {
                  required: false,
                  message: null,
                },
              ]
            )
          }
        }
      },
      vaildateTimeEnd() {
        return (row, index) => {
          if (
            !(
              !this.isCurrentMonth ||
              this.isEqualCodeEnum(
                row.resultDateInputStatus,
                this.$divisions.resultDateInputStatusEnum.enum_2
              ) ||
              this.$baseLodash.isEmpty(row.resultWorkStartDate)
            )
          ) {
            this.$set(this.rulesTable, `tableList.${index}.resultWorkEndTime`, [
              {
                required: true,
                message: this.format(
                  this.$t(
                    `validateMessage.${this.$messageCode.E00000001.name}`
                  ),
                  '作業実績日時'
                ),
                trigger: 'blur',
              },
            ])
          } else {
            this.$set(this.rulesTable, `tableList.${index}.resultWorkEndTime`, [
              {
                required: false,
                message: null,
              },
            ])
          }
        }
      },
      isCurrentMonth() {
        return this.queryForm.workYm == this.$dayjs().format('YYYYMM')
      },
    },
    watch: {
      async 'queryForm.itemDetailCdList'(list) {
        if (this.$baseLodash.isEmpty(list)) {
          this.workSpecCdListDisabled = true
        } else {
          this.workSpecCdListDisabled = false
          // 点検仕様
          this.workSpecCdList = await getFoundSelfData({
            itmdtlcd: list,
          })
        }
      },
      'queryForm.workYm': {
        handler(val) {
          if (val) {
            this.workYmlimit = false
          } else {
            this.workYmlimit = true
            this.queryForm.planWorkStartDate = null
            this.queryForm.planWorkEndDate = null
          }
        },
        deep: true,
      },
      isCurrentMonth() {
        if (this.isCurrentMonth) {
          this.btnUpdate[0].disabled = false
          this.navButtons.filter((item) => {
            item.disabled = false
          })
        } else {
          this.btnUpdate[0].disabled = true
          this.navButtons.filter((item) => {
            item.disabled = true
          })
        }
      },
    },
    mounted() {
      this.queryForm.workYm = this.$route.query.workYm
        ? this.$route.query.workYm
        : this.$dayjs().format('YYYYMM')
    },
    methods: {
      // 商品明細
      clearOtherData() {
        this.$refs.workSpecRef.setValue([])
        this.queryForm.workSpecCdList = []
      },
      submitTable(data) {
        this.$refs.form.clearValidate()
        // 前回の初期化データ
        let oldInitTableList = this.$baseLodash.cloneDeep(this.initTableList)
        // 現在のページングデータ
        this.initTableList = this.$baseLodash.cloneDeep(data.dataSource)
        this.form.tableList = data.dataSource
        // 登録
        this.update(true, data.oldList, oldInitTableList)
      },
      // データを提出する
      update(
        flag = false,
        list = this.$refs.table.dataSource,
        originArr = this.initTableList
      ) {
        let updateList = this.getSubmitList(list, originArr)
        if (flag) {
          if (updateList.length == 0) return
          let errorList = []
          updateList.forEach((item) => {
            if (
              !item.disabled &&
              item.resultWorkStartDate &&
              (!item.resultWorkStartTime || !item.resultWorkEndTime)
            ) {
              errorList.push(item)
            }
          })
          updateList = this.$baseLodash.difference(updateList, errorList)
          if (updateList.length == 0) return
          let msg = ''
          if (errorList.length > 0) {
            msg = this.$t(`validateMessage.${this.$messageCode.I00000439.name}`)
          } else {
            msg = this.$t(`validateMessage.${this.$messageCode.I00000408.name}`)
          }
          this.$confirm({
            msg: msg,
            yesText: '確定',
            yes: () => {
              return this.handleUpdate(updateList)
            },
            no: () => {
              return false
            },
          })
        } else {
          this.handleUpdate(updateList)
        }
      },
      handleWorkYmChange() {
        this.queryForm.planWorkStartDate = null
        this.queryForm.planWorkEndDate = null
      },
      // 作業年月チェック
      workYmValidate(rule, value, callback) {
        if (this.$baseLodash.isEmpty(this.queryForm.workYm)) {
          return callback(
            new Error(
              format(
                this.$t(`validateMessage.${this.$messageCode.E00000001.name}`),
                '作業年月'
              )
            )
          )
        }
        callback()
      },
      // 検索ボタン
      fetchData() {
        this.$refs.table.fetchData().then(() => {
          this.initTableList = this.$baseLodash.cloneDeep(
            this.$refs.table.dataSource
          )
          this.$set(
            this.form,
            'tableList',
            this.$baseLodash.cloneDeep(this.$refs.table.dataSource)
          )
        })
      },
      // 予定を反映
      handleWorkResultUpdate(row) {
        if (
          !this.isEqualCodeEnum(
            row.resultDateInputStatus,
            this.$divisions.resultDateInputStatusEnum.enum_2
          ) &&
          this.isCurrentMonth
        ) {
          this.form.tableList.filter((item, index) => {
            if (item?.workingPlanAndResultId == row?.workingPlanAndResultId) {
              if (row.planWorkStartDate) {
                item.resultWorkStartDate = row.planWorkStartDate
                this.$refs.table.dataSource[index].resultWorkStartDate =
                  row.planWorkStartDate
              }
              if (row.planWorkStartTime) {
                item.resultWorkStartTime = row.planWorkStartTime
                let prop = `tableList.${index}.resultWorkStartTime`
                this.$refs.form.clearValidate([prop])
                this.$refs.table.dataSource[index].resultWorkStartTime =
                  row.planWorkStartTime
              }
              if (row.planWorkEndTime) {
                item.resultWorkEndTime = row.planWorkEndTime
                let prop = `tableList.${index}.resultWorkEndTime`
                this.$refs.form.clearValidate([prop])
                this.$refs.table.dataSource[index].resultWorkEndTime =
                  row.planWorkEndTime
              }
              // this.$refs.table.dataSource[index] = item
              this.$set(
                this.form,
                `tableList.${index}.resultWorkStartDate`,
                item.planWorkStartDate
              )
              this.$forceUpdate()
            }
          })
        }
      },
      // 予定を一括反映
      handleWorkResultUpdateAll() {
        this.$refs.table.dataSource.forEach((row) => {
          this.handleWorkResultUpdate(row)
        })
      },
      // 更新
      async handleUpdate(list) {
        this.$baseColorfullLoading()
        try {
          await workResultUpdate(list)
          this.msgSuccess(
            this.format(
              this.$t(`validateMessage.${this.$messageCode.I00000109.name}`),
              '作業実施日'
            )
          )
        } finally {
          this.$baseColorfullLoading().close()
        }
        this.fetchData()
      },
      // リセット時間です
      timeReset(val, index) {
        if (!val) {
          this.$refs.table.dataSource[index].resultWorkStartDate = null
          this.$refs.table.dataSource[index].resultWorkStartTime = null
          this.$refs.table.dataSource[index].resultWorkEndTime = null
        }
      },
    },
  }
</script>

<style lang="scss" scoped>
  @import '@/vab/styles/reportRc.scss';
</style>

<style lang="scss" scoped>
  .workresultlistdiv {
    .flex_space {
      justify-content: flex-end;
    }

    .vab-theme-darkBlue-black .el-button--primary {
      background: #ffffff !important;
      border: 1px solid #0060c2 !important;
      border-radius: 3px !important;
      color: #0060c2 !important;
    }

    .firtcoldiv {
      display: flex;
      justify-content: space-around;
      align-items: center;
      .datediv {
        display: flex;
        align-items: center;
      }
      .input_160 {
        width: 60px;
        height: 28px;
        background: #ffffff;
      }
      .firstcoloinput {
        padding: 0px;
        width: 50px;
        height: 28px;
        background: #ffffff;
        border-radius: 3px;
      }
    }
    ::v-deep .changebtn {
      background: #ffffff !important;
      border: 1px solid #0060c2 !important;
      border-radius: 3px !important;
      color: #0060c2 !important;
    }
    ::v-deep .el-button.is-disabled {
      color: #a1a1a1 !important;
      border-color: #cecece !important;
      background: #efefef !important;
    }

    ::deep [class^='el-icon-'],
    [class*=' el-icon-'] {
      display: none;
    }

    .searchdateinputrow {
      display: flex;
      align-items: center;
      .searchdateinput {
        width: 80px;
        height: 32px;
        background: #ffffff;
      }
      .space {
        margin-right: 8px;
      }
      .searchdateinputsplit {
        padding: 0px 6px;
        line-height: 2.3;
      }
    }
  }

  .el_row_box {
    padding: 0 2px;
  }

  .input_60 {
    width: 60px !important;
  }
  .input_50 {
    width: 50px !important;
    ::v-deep .el-input__inner {
      text-align: center;
    }
  }

  .date-picker-icon {
    width: 100%;
    &.date-close:hover {
      ::v-deep {
        .el-input__prefix {
          display: none !important;
        }
      }
      .el-icon-date {
        display: none;
      }
    }
    ::v-deep {
      .el-input__inner {
        padding-left: 5px !important;
        padding-right: 25px !important;
      }

      .el-input__prefix {
        left: initial;
        right: 5px;
      }
    }
  }
  .week_show {
    display: inline-block;
    width: 36px;
    line-height: 150%;
    font-weight: 400;
    font-size: 12px;
    color: #000000;
  }
</style>
